import React from 'react'
import { useState, useRef } from 'react'
import { Editor } from '../Editor/Editor'
import { useDebounce } from '../../../../hooks/useDebounce'
import { ButtonWithIcon } from '../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon'
import Aa from './img/Aa.svg'
import selected_icon from './img/selected.svg'
import "./TitleText.scss"


const TitleText = (({
    id,
    data,
    changeContent,
    setIsModal,
    ind,
    setCurrentIndex,
    before,
    setBeforeBlock,
    setContentArr,
    readonly = false,
    addNewBlock,
}) => {
    const [content, setContent] = useState(data[0]?.value)
    const ref = useRef()
    const [isEditor, setIsEditor] = useState(false)

    const debounceChange = useDebounce(changeContent, 1000)

    const handleInput = (e) => {
        debounceChange(id,
            [
                {
                    value: ref?.current?.innerHTML,
                    properties: {}
                }
            ]
        )
        setContentArr((prev) => {
            return prev.map((el) => {
                if (el?.block_id == id) {
                    return {
                        ...el,
                        content: [
                            {
                                value: ref?.current?.innerHTML
                            }
                        ]
                    }
                } else {
                    return el
                }
            })
        })
    }

    const handlePaste = (event) => {
        event.preventDefault();

        let clipboardData = event.clipboardData || window.clipboardData;
        let pastedHTML = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

        if (pastedHTML) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(pastedHTML, 'text/html');

            // Удаляем все теги <br>
            doc.querySelectorAll('br').forEach(el => el.remove());

            // Оставляем только безопасные теги
            const allowedTags = ['p', 'b', 'i', 'u', 'a'];
            doc.body.querySelectorAll('*').forEach(el => {
                if (!allowedTags.includes(el.tagName.toLowerCase())) {
                    el.replaceWith(...el.childNodes); // Заменяем на чистый текст
                }
            });

            let cleanHTML = doc.body.innerHTML;

            // Вставляем очищенный HTML без форматирования
            document.execCommand('insertHTML', false, cleanHTML);
        }
    }

    // Обработчик нажатия клавиш
    const handleKeyDown = (e) => {
        // Обработка Ctrl+Enter для красной строки
        if (e.ctrlKey && e.key === 'Enter') {
            e.preventDefault();
            document.execCommand('insertLineBreak')
            return
        }

        if (e.key === 'Enter') {
            e.preventDefault();
            addNewBlock();
            return
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }}>
            {/* <TextEditor /> */}
            {!readonly &&
                (isEditor && <Editor
                    handleInput={handleInput}
                />)}

            <div className='article-text__wrapper'>
                {!readonly && <ButtonWithIcon
                    icon={Aa}
                    size='xs'
                    onClick={(e) => setIsEditor(!isEditor)}
                    style={{ marginTop: '8px' }}
                />}

                {!readonly && <ButtonWithIcon
                    icon={selected_icon}
                    size='xs'
                    onClick={(e) => {
                        setCurrentIndex(ind)
                        setIsModal(true)
                    }}
                    style={{ marginTop: '8px' }}
                />}

                <h2
                    id={id}
                    maxLength={20}
                    suppressContentEditableWarning
                    ref={ref}
                    className={`article__title`}
                    contentEditable={!readonly}
                    dangerouslySetInnerHTML={{ __html: content }}
                    onInput={(e) => handleInput(e)}
                    onPaste={handlePaste}
                    onContextMenu={(e) => {
                        if (!readonly) {
                            e.preventDefault()
                            setCurrentIndex(ind)
                            setIsModal(true)
                        }
                    }}
                    onKeyDown={handleKeyDown}
                    onClick={(e) => {
                        setCurrentIndex(ind)
                        setBeforeBlock(before)
                    }}
                ></h2 >
            </div>
        </div>
    )
})

export { TitleText }